/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_Select_File_LabelInputs */

const en_options_cli_select_file_label = /** @type {(inputs: Options_Cli_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select file`)
};

const fr_options_cli_select_file_label = /** @type {(inputs: Options_Cli_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner un fichier`)
};

const de_options_cli_select_file_label = /** @type {(inputs: Options_Cli_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei auswählen`)
};

const it_options_cli_select_file_label = /** @type {(inputs: Options_Cli_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona file`)
};

const ru_options_cli_select_file_label = /** @type {(inputs: Options_Cli_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите файл`)
};

const es_options_cli_select_file_label = /** @type {(inputs: Options_Cli_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar archivo`)
};

const zh_cn2_options_cli_select_file_label = /** @type {(inputs: Options_Cli_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择文件`)
};

const ja_options_cli_select_file_label = /** @type {(inputs: Options_Cli_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルを選択`)
};

const hi_options_cli_select_file_label = /** @type {(inputs: Options_Cli_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल का चयन करें`)
};

const pt_pt2_options_cli_select_file_label = /** @type {(inputs: Options_Cli_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar arquivo`)
};

/**
* | output |
* | --- |
* | "Select file" |
*
* @param {Options_Cli_Select_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_select_file_label = /** @type {((inputs?: Options_Cli_Select_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Select_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_cli_select_file_label(inputs)
	if (locale === "de") return de_options_cli_select_file_label(inputs)
	if (locale === "it") return it_options_cli_select_file_label(inputs)
	if (locale === "ru") return ru_options_cli_select_file_label(inputs)
	if (locale === "es") return es_options_cli_select_file_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_cli_select_file_label(inputs)
	if (locale === "ja") return ja_options_cli_select_file_label(inputs)
	if (locale === "hi") return hi_options_cli_select_file_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_cli_select_file_label(inputs)
	return en_options_cli_select_file_label(inputs)
});